import { connect } from 'react-redux';

import {
    ordersDetailsInvalidate,
    ordersDetailsFetchIfNeeded,
    ordersSetViewedFetchIfNeeded,
    ordersFilesFetchIfNeeded,
    ordersSetFavoriteFetch,
    ordersSetStatusAcceptedFetch,
    ordersSetStatusCompletedFetch,
    ordersMessagesFetch,
    ordersMessagesSetReadFetch,
    ordersMessagesAddFetch,
    orderFilesUploadFetch,
    ordersMessagesAddAttachFetch,
    ordersFilesRemoveFetch,
    ordersHideInLists
} from './../store/orders/actions';
import { ordersCompleteFetchIfNeeded } from './../store/ordersComplete/actions';

import Order from './../components/order/Order';

const mapStateToProps = (state, ownProps) => {
    const orderNumber = ownProps.orderNumber;
    const order = state.orders[orderNumber];
    const hasOrderInList = !!order;
    const error = hasOrderInList ? order.error : null;
    const isFilesLoading = !hasOrderInList || !order.files || order.files.isFetching || order.files.didInvalidate;
    const isMessagesLoading = !hasOrderInList || !order.messages || order.messages.isFetching || order.messages.didInvalidate;
    const isLoading = !hasOrderInList || order.isFetching || order.didInvalidate || isFilesLoading || isMessagesLoading;
    const fileItems = !hasOrderInList || !order.files || !order.files.items ? {} : order.files.items;
    const messageList = !hasOrderInList || !order.messages || !order.messages.items ? [] : Object.values(order.messages.items);
    const isLoadingAdd = !hasOrderInList || !order.messages ? true : order.messages.isFetchingAdd;
    const isStatusLoading = hasOrderInList && order.isFetchingStatus;
    return { hasOrderInList, isLoading, order, error, fileItems, isStatusLoading, messageList, isLoadingAdd };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const orderNumber = ownProps.orderNumber;

    return {
        loadDetails: () => {
            dispatch(ordersDetailsFetchIfNeeded(orderNumber));
            dispatch(ordersSetViewedFetchIfNeeded(orderNumber));
            dispatch(ordersFilesFetchIfNeeded(orderNumber));
            dispatch(ordersMessagesFetch(orderNumber));
        },
        invalidate: () => dispatch(ordersDetailsInvalidate(orderNumber)), 
        loadOrders: () => dispatch(ordersCompleteFetchIfNeeded()),
        setFavorite: value => dispatch(ordersSetFavoriteFetch(orderNumber, value)),
        setAccepted: () => dispatch(ordersSetStatusAcceptedFetch(orderNumber)),
        setCompleted: () => dispatch(ordersSetStatusCompletedFetch(orderNumber)),
        setMessageRead: messageId => dispatch(ordersMessagesSetReadFetch(orderNumber, messageId)),
        addMessage: (to, message) => dispatch(ordersMessagesAddFetch(orderNumber, to, message)),
        uploadFile: (file, group) => dispatch(orderFilesUploadFetch(orderNumber, file, group)),
        addMessageAttach: (to, files, message) => dispatch(ordersMessagesAddAttachFetch(orderNumber, to, files, message)),
        removeFile: fileId => dispatch(ordersFilesRemoveFetch(orderNumber, fileId)),
        hideInLists: number => dispatch(ordersHideInLists(orderNumber))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Order);



// WEBPACK FOOTER //
// ./src/pages/OrderCompleteTabPage.js